/**
 * Centralized UI strings for the PFS Portal application
 * This file contains all user-facing text to prevent brittle tests
 * and enable easy maintenance and future internationalization
 */

export const UI_STRINGS = {
  LOGIN: {
    TITLE: 'Facility safety authentication',
    SIGN_IN_BUTTON: 'Sign In',
    REGISTER_BUTTON: 'Register',
    EMAIL_PLACEHOLDER: 'Enter your email address',
    EMAIL_LABEL: 'Email Address',
    EMAIL_VALIDATION_MESSAGE: 'Please enter a valid email address.',
    EMAIL_INSTRUCTION: 'Please enter your email address.',
    ALREADY_REGISTERED: 'Already Registered?',
    REGISTER_ANOTHER_ACCOUNT: 'Register Another Account',
    ACCOUNT_ALREADY_REGISTERED: 'This account is already registered. Please proceed to Sign In.',
    CONGRATULATIONS_TITLE: 'Title',
    CONGRATULATIONS_MESSAGE: 'Congratulation. You account has been registered. You will be redirected to the login screen to access your account.',
    OK_BUTTON: 'OK',
    NO_ACTIVE_ACCOUNT: 'There is no active account associated with this email.',
    NO_ACCOUNT_ERROR: 'There is no account associated with this email',
    INACTIVE_SIGN_IN_TITLE: 'You do not have sufficient rights in the LSC Roster to view PFS data.',
    INACTIVE_SIGN_IN_CONTACT: 'Contact the national program office via email for further assistance. Include your name, email address, and facility affiliation.'
  },
  ACCOUNT: {
    CREATED_TITLE: 'Account Created',
    CREATED_MESSAGE: 'Your account has been registered successfully. Please proceed to the login.',
    PROCEED_BUTTON: 'Proceed to Login',
    FIRST_NAME_LABEL: 'First Name:',
    LAST_NAME_LABEL: 'Last Name:',
    EMAIL_LABEL: 'Email:'
  },
  HEADER: {
    TITLE: 'Safety Data Portal',
    GRAVATAR_ALT: 'gravatar',
    PLANE_ALT: 'plane'
  },
  BANNER: {
    DEFAULT_MODAL_TITLE: 'Notice',
    ACKNOWLEDGE_BUTTON: 'I Understand'
  },
  SECURITY: {
    UNAUTHORIZED_ACCESS: 'Access to this system is for authorized users only',
    SUPPORT_EMAIL: '9-aji-ask-pfs@faa.gov'
  },
  SUPPORT: {
    CONTACT_US: 'Contact Us',
    CONTACT_MESSAGE: 'If you have any questions or need assistance, please reach out to our support team at ',
    EMAIL_LINK_TEXT: 'PFSusersupport@cssiinc.com',
    UNEXPECTED_ERROR_MESSAGE: 'Please take a screenshot of your entire browser window and email it to ' +
        'PFSusersupport@cssiinc.com along with the email or username you used to sign in to PFS and ' +
        'the date and time when the error occurred. This information will reduce the amount of time ' +
        'it takes to identify and resolve the issue. ' +
        ' Someone from our support team will get back to you. Do not include ' +
        'any sensitive information in the screenshot.',
  },
  LOADING_STATES: {
    IDLE: 'IDLE',
    LOADING: 'LOADING',
    DONE: 'DONE',
    ERROR: 'ERROR'
  }
} as const;

// Type for autocomplete and type safety
export type UIStringKeys = typeof UI_STRINGS;
